import React, { Component } from 'react'
import { connect } from 'react-redux'
import { toast } from 'react-toastify'

import { getSelectedLanguageContent } from 'utils'
import { convertObjectToBase64 } from 'utils/objToBase64'
import { Get, Post, Put, Delete } from 'utils/axios'
import { addLoadingContent, removeLoadingContent } from 'reducers/LoadingOverlay'

const HOC = ( WrappedComponent ) => {
  class WithHOC extends Component {
    state = {
      query: { filter: {}, sorter: { reward_type_ids: 'desc' }, page: 1, page_size: 10 },
      rewardPrograms: [],
      tableMetadata: { page: 1, pageSize: 10, totalPages: 1, totalCount: 0 },
      onLoadRewardPrograms: false
    }

    load = param => {
      this.setState({ onLoadRewardPrograms: param })
      if( param ){
        this.props.addLoadingContent()
      } else {
        this.props.removeLoadingContent()
      }
    }
    requestSuccess = success => toast.success( success )
    requestError = error => toast.error( error?.message || error )

    onChangeRewardProgramsHOC = ( key, val ) => this.setState({ [ key ]: val })

    getRewardPrograms = () => Get(
      `/reward-programs?query=${ convertObjectToBase64( this.state.query )}`,
      this.getRewardProgramsSuccess,
      this.requestError,
      this.load
    )
    getRewardProgramsSuccess = payload => this.setState({
      rewardPrograms: payload.rows,
      tableMetadata: payload.meta
    })

    getRewardProgram = ( id, onSuccess ) => Get(
      `/reward-programs/${ id }`,
      payload => onSuccess( payload ),
      this.requestError,
      this.load
    )

    createRewardProgram = ( data, onSuccess ) => Post(
      `/reward-programs`,
      data,
      () => {
        this.requestSuccess( getSelectedLanguageContent("{{REWARD_PROGRAM_IS_CREATED}}") )
        this.getRewardPrograms()
        onSuccess()
      },
      this.requestError,
      this.load
    )

    updateRewardProgram = ( id, data, onSuccess ) => Put(
      `/reward-programs/${ id }`,
      data,
      () => {
        this.requestSuccess( getSelectedLanguageContent("{{REWARD_PROGRAM_IS_UPDATED}}") )
        this.getRewardPrograms()
        onSuccess && onSuccess()
      },
      this.requestError,
      this.load
    )

    deleteRewardProgram = ( id, onSuccess ) => Delete(
      `/reward-programs/${ id }`,
      () => {
        this.requestSuccess( getSelectedLanguageContent("{{REWARD_PROGRAM_IS_DELETED}}") )
        this.getRewardPrograms()
        onSuccess()
      },
      this.requestError,
      this.load
    )

    render = () => {
      return (
        <WrappedComponent
          { ...this.props }
          onChangeRewardProgramsHOC={ this.onChangeRewardProgramsHOC }
          getRewardPrograms={ this.getRewardPrograms }
          getRewardProgram={ this.getRewardProgram }
          createRewardProgram={ this.createRewardProgram }
          updateRewardProgram={ this.updateRewardProgram }
          deleteRewardProgram={ this.deleteRewardProgram }
          query={ this.state.query }
          rewardPrograms={ this.state.rewardPrograms }
          tableMetadata={ this.state.tableMetadata }
          onLoadRewardPrograms={ this.state.onLoadRewardPrograms }
        />
      )
    }
  }

  const mapStateToProps = state => ({
    data: state,
    colors: state.ClientReducer.clientInfo.styles?.colors,
    selectedLanguage: state.ProfileReducer.profile.preferred_language,
    siteInfo: state.ClientReducer.siteInfo
  })
  return connect( mapStateToProps, { addLoadingContent, removeLoadingContent } )( WithHOC )
}

export default HOC
